export default __webpack_public_path__ + "media/images/promo-block/website-settings-f75b9afeec60c903681be1494f1111f7.gif";